/** Estilos reutilizables basados en tokens de plantilla (--cta-*, --org-header-*, --fichar-*, --worker-zonas-*). */

function hslVar(name, fallback) {
  return `hsl(var(--${name}, ${fallback}))`;
}

/** Botón rojo de acción (Publicar, guardar festivo, etc.). */
export function ctaButtonStyle() {
  return {
    background: `linear-gradient(to bottom right, ${hslVar("cta-from", "347 77% 50%")}, ${hslVar("cta-to", "350 89% 60%")})`,
    color: hslVar("cta-foreground", "0 0% 100%"),
  };
}

/** Encabezado principal de Organización (indigo → violeta → fucsia). */
export function orgHeaderStyle(direction = "to bottom right") {
  return {
    background: `linear-gradient(${direction}, ${hslVar("org-header-from", "239 84% 67%")}, ${hslVar("org-header-via", "258 90% 66%")}, ${hslVar("org-header-to", "292 84% 61%")})`,
    color: hslVar("org-header-foreground", "0 0% 100%"),
  };
}

/** Botón circular «Entrar» en Fichar. */
export function ficharEntrarButtonStyle() {
  return {
    background: `linear-gradient(to bottom right, ${hslVar("fichar-btn-from", "239 84% 67%")}, ${hslVar("fichar-btn-to", "258 90% 66%")})`,
    boxShadow: `0 0 0 4px ${hslVar("fichar-btn-ring", "239 58% 90%")}`,
  };
}

/** Panel del reloj en Fichar. */
export function ficharSurfaceStyle() {
  return {
    background: hslVar("fichar-surface", "240 45% 96%"),
    borderColor: hslVar("fichar-surface-border", "239 58% 90%"),
  };
}

export function ficharLabelColor() {
  return { color: hslVar("fichar-label", "239 84% 57%") };
}

/** Cabecera de «Mis zonas» (trabajador). */
export function workerZonasHeaderStyle() {
  return {
    background: `linear-gradient(to bottom right, ${hslVar("worker-zonas-bg-from", "292 100% 98%")}, ${hslVar("worker-zonas-bg-to", "270 100% 98%")})`,
    borderColor: hslVar("worker-zonas-border", "292 84% 90%"),
  };
}

export function workerZonasAccentStyle() {
  return {
    background: hslVar("worker-zonas-accent", "258 90% 66%"),
    color: hslVar("worker-zonas-accent-fg", "0 0% 100%"),
  };
}

export function workerZonasSubtitleStyle() {
  return { color: hslVar("worker-zonas-subtitle", "258 55% 40%") };
}
